(function() {
  var BaseStep, FieldModel, StringUtil,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseStep = App.loadClass("grower::viewmodels/fields/add/steps/BaseStep");

  FieldModel = App.loadClass("grower::viewmodels/fields/add/Field");

  StringUtil = App.load("core::utils/string");

  exports.Form = (function(superClass) {
    extend(Form, superClass);

    Form.prototype.history = [];

    Form.prototype._temp_history = [];

    Form.prototype.defaultFirstStep = "selectAddOrUpload";

    Form.prototype.setInitialDeps = function() {
      return this.syncDeps({
        "FieldModel": FieldModel,
        "uploadStart": "grower::viewmodels/fields/add/steps/UploadStart",
        "saveField": "grower::viewmodels/fields/add/steps/SaveField"
      });
    };

    function Form(handler, data, deps) {
      var ref;
      if (data == null) {
        data = {};
      }
      if (deps == null) {
        deps = {};
      }
      this.goBack = bind(this.goBack, this);
      this.changeStep = bind(this.changeStep, this);
      this.finish = bind(this.finish, this);
      Form.__super__.constructor.call(this);
      this.setInitialDeps();
      this.syncDeps(deps);
      this.handler = handler;
      this.currentStep = ko.observable();
      this.currentStepInstance = ko.observable();
      this.currentMode = ko.observable("");
      this.currentField = ko.observable(new (this.getDep("FieldModel"))(data.data));
      this.errors = ko.observableArray([]);
      this.changeStep(this.defaultFirstStep);
      this.year = (ref = data.year) != null ? ref : null;
    }

    Form.prototype.reset = function() {
      return this.currentField(new (this.getDep("FieldModel")));
    };

    Form.prototype.registerCustomBindings = function() {
      return ko.bindingHandlers.goToStep = {
        init: (function(_this) {
          return function(element, valueAccessor) {
            var value;
            value = ko.unwrap(valueAccessor());
            return $(element).on('click', function() {
              if ($.isFunction(value)) {
                return value();
              } else {
                return _this.changeStep(value);
              }
            });
          };
        })(this)
      };
    };

    Form.prototype.finish = function() {
      return this.handler.parent.parent.refresh();
    };


    /*
    
    Step changing; we try to resolve a dependency matching the step we're trying to change to.
    If there's a dependency that matches, we instantiate that clase, otherwise, we create an instance
    of the generic BaseStep class.
    
    There are two entities of importance during the switch;
    - the old step we're changing from (oldStep)
    - the new step we're changing to (newStep)
    
    Here's the order of callbacks:
    
    - oldStep.beforeNext() (or beforePrev, if goingBackwards)
        - if this returns false (literal false), we don't change steps.
    - newStep.beforeSet()
        - if this returns false (literal false), we don't change steps
    - We set the newStep to be current
    - oldStep.afterNext() (or afterPrev, if goingBackwards)
    - newStep.afterSet()
     */

    Form.prototype.changeStep = function(stepName, goingBackwards, set_cb) {
      var fn, oldStep, step;
      if (goingBackwards == null) {
        goingBackwards = false;
      }
      oldStep = this.currentStepInstance();
      if (oldStep != null) {
        if (goingBackwards) {
          fn = 'beforePrev';
        } else {
          fn = 'beforeNext';
        }
        if (oldStep[fn](stepName) === false) {
          return;
        }
      }
      if ((this.stepChangeModifier != null) && $.isFunction(this.stepChangeModifier)) {
        stepName = this.stepChangeModifier(this.currentStep(), stepName, goingBackwards);
        if (stepName === false) {
          return;
        }
      }
      if (this.getDep(stepName)) {
        step = new (this.getDep(stepName))(this);
      } else {
        step = new BaseStep(this);
      }
      if (step.beforeSet() === false) {
        return;
      }
      if (!goingBackwards) {
        this.history.push(this.currentStep());
      }
      this.currentStep(stepName);
      this.currentStepInstance(step);
      this.currentStepInstance().__name(stepName);
      this.errors([]);
      this.history = this._temp_history;
      if (oldStep != null) {
        if (goingBackwards) {
          fn = 'afterPrev';
        } else {
          fn = 'afterNext';
        }
        oldStep[fn]();
      }
      if (set_cb != null) {
        set_cb(step);
      }
      return step.afterSet();
    };

    Form.prototype.goBack = function() {
      var prev;
      prev = this.currentStepInstance().getPrev();
      if (prev == null) {
        return;
      }
      return this.changeStep(prev, true);
    };

    Form.prototype.clearHistoryPrev = function() {
      var history, prev;
      history = this.history.slice();
      prev = history.pop();
      this._temp_history = history;
      return prev;
    };

    Form.prototype.clearHistoryAt = function(page) {
      var history, ind;
      history = this.history.slice();
      ind = history.indexOf(page);
      if (ind !== -1) {
        history.splice(ind, history.length);
      }
      return this._temp_history = history;
    };

    Form.prototype.clearHistoryAfter = function(page) {
      var history, ind;
      history = this.history.slice();
      ind = history.indexOf(page);
      if (ind !== -1) {
        history.splice(ind + 1, history.length);
      }
      return this._temp_history = history;
    };

    Form.prototype.destroy = function() {
      var ref;
      if ((ref = this.currentStepInstance()) != null) {
        if (typeof ref.destroy === "function") {
          ref.destroy();
        }
      }
      return this.currentField().destroy();
    };

    return Form;

  })(KoModel);

}).call(this);
